import { Grid } from '@mui/material';
import * as React from 'react';
import { FixedSizeList } from 'react-window';
import { useGroupsList } from '../../../../sic-lib/api/hooks/useGroupsList';
import { useAppSelector } from '../../../../store/hooks';
import PageStatus from '../../../Navigation/PageStatus/PageStatus';
import GroupsListItem from '../GroupsListItem/GroupsListItem';
import Segments from '../Segments/Segments';

interface Props {}

export default function GroupsList({}: Props) {
    const hasEngagePlatform = useAppSelector(state => state.user.clientHasEngagePlatform);

    const { data, isSuccess, isFetching, isLoading, isError } = useGroupsList();

    const [listHeight, setListHeight] = React.useState<number>(0);

    const listRef = React.useRef<HTMLDivElement | null>(null);

    React.useEffect(() => {
        if (listRef.current) {
            const { height } = listRef.current.getBoundingClientRect();

            setListHeight(height);
        }
    }, []);

    return (
        <div ref={listRef}>
            <PageStatus showError={isError} showLoading={!isSuccess || isLoading}>
                <Grid container>
                    <FixedSizeList
                        // height={listHeight}
                        height={data ? data.length * 57 : 0}
                        itemCount={data ? data.length : 0}
                        itemData={data || []}
                        itemSize={57}
                        width="100%"
                    >
                        {({ data, index, style }) => (
                            <div style={style}>
                                <GroupsListItem
                                    key={data[index].listId}
                                    listId={data[index].listId}
                                    type={data[index].type}
                                    name={data[index].name}
                                />
                            </div>
                        )}
                    </FixedSizeList>
                    {hasEngagePlatform && (
                        <Segments windowHeight={listHeight - (data ? data?.length * 57 : 0)} />
                    )}
                </Grid>
            </PageStatus>
        </div>
    );
}
